import { render, staticRenderFns } from "./domLegend.vue?vue&type=template&id=7f280f7d&scoped=true&"
import script from "./domLegend.vue?vue&type=script&lang=js&"
export * from "./domLegend.vue?vue&type=script&lang=js&"
import style0 from "./domLegend.vue?vue&type=style&index=0&id=7f280f7d&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f280f7d",
  null
  
)

export default component.exports